export { default as Academy } from './academy/index';
export * from './account';
export * from './add-page';
export * from './analysis';
export * from './assistant';
export * from './auth';
export * from './courses';
export * from './dashboard';
export * from './explore';
export * from './payment';
export * from './profile';
export * from './subscription';
export * from './support';
export * from './videos';
export * from './wallet';

